import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { LandingPageGetDto } from "../dto";

@Injectable({ providedIn: "root" })
export class LandingService {
  protected serviceUrl = "Landing";

  constructor(protected api: ApiService) {}

  getByWidgetId(widgetId: number): Observable<LandingPageGetDto> {
    return this.api.get(`${this.serviceUrl}/widget/${widgetId}`, {});
  }
}
